import { HyperBackendMethod } from "@shared/backend/hyper-backend-method";
import { pick } from "lodash";
import { Allow, Controller, repo } from "remult";
import type { AvailabilityBase } from "../availability-base";
import { UserAvailability } from "./entity";

@Controller("user-availability-methods")
export class UserAvailabilityMethods {
  @HyperBackendMethod({
    apiPrefix: "user-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async replaceAll(userId: string, availability: AvailabilityBase[]) {
    await repo(UserAvailability).deleteMany({
      where: {
        userId,
        dow: {
          $in: availability.map((v) => v.dow),
        },
      },
    });

    return await repo(UserAvailability).insert(
      availability.map((v) => ({
        ...v,
        userId,
      })),
    );
  }

  @HyperBackendMethod({
    apiPrefix: "user-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async updateOne(userId: string, availability: AvailabilityBase) {
    return await repo(UserAvailability).updateMany({
      where: {
        userId,
        dow: availability.dow,
      },
      set: pick(availability, "morning", "afternoon", "evening"),
    });
  }

  @HyperBackendMethod({
    apiPrefix: "user-availability-methods",
    allowed: Allow.authenticated,
    overrideSecurity: true,
  })
  static async create(userId: string, availability: AvailabilityBase[]) {
    return await repo(UserAvailability).insert(
      availability.map((v) => ({
        ...v,
        userId,
      })),
    );
  }
}
